/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * RotateCwIcon
 */
export default class RotateCwIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M18.926 8a3 3 0 013 3v8a3 3 0 01-3 3h-8a3 3 0 01-3-3v-8a3 3 0 013-3zm0 2h-8a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1v-8a1 1 0 00-1-1zm-8.68-8.793l.093.085 1.963 2.056a1 1 0 01.07 1.3l-.08.092-1.916 1.946a1 1 0 01-1.508-1.308l.083-.095.276-.281a5 5 0 00-4.828 6.95 1 1 0 01-1.84.782A7 7 0 019.204 3l-.024-.025-.289-.301a1 1 0 01-.053-1.322l.086-.092a1 1 0 011.321-.053z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

